import React, {Component} from 'react';
import {Button} from "antd";

/**
 * creat by tianruojun
 * @description 按钮
 * @class Button_rmt
 * @extends {Component}
 */
export default class Button_rmt extends Component {
    render() {
        let {onChange,labelName} = this.props;
        return (
            <Button type={'primary'} onClick={()=>{onChange({})}}>{labelName}</Button>
        )
    }

}